<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 17 21">
    <g clip-path="url(#clip0_6892_9057)">
      <path
        d="M10.0403 13.5325C10.0403 13.9877 9.78168 14.3568 9.42448 14.5782V17.2232H8.19277V14.5782C7.83557 14.3691 7.57691 13.9877 7.57691 13.5325C7.57691 12.8559 8.13118 12.3023 8.80863 12.3023C9.48607 12.3023 10.0403 12.8559 10.0403 13.5325ZM16.7778 10.4446V19.1547C16.7778 20.1757 15.9526 21 14.9303 21H2.62541C1.60308 21 0.777832 20.1757 0.777832 19.1547V10.4446C0.777832 9.42355 1.60308 8.5993 2.62541 8.5993H2.65004V6.15114C2.65004 2.75571 5.4214 0 8.80863 0C12.1958 0 14.9672 2.75571 14.9672 6.15114V8.5993C15.9649 8.6239 16.7778 9.43585 16.7778 10.4446ZM3.88176 8.5993H13.7355V6.15114C13.7355 3.43234 11.5307 1.23023 8.80863 1.23023C6.08653 1.23023 3.88176 3.43234 3.88176 6.15114V8.5993ZM15.5461 10.4446C15.5461 10.1248 15.2875 9.86643 14.9672 9.84183H2.65004L2.62541 9.82953C2.28053 9.82953 2.00955 10.1002 2.00955 10.4446V19.1547C2.00955 19.4991 2.28053 19.7698 2.62541 19.7698H14.9303C15.2628 19.7698 15.5461 19.4991 15.5461 19.1547V10.4446Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9057">
        <rect width="16" height="21" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
